import { Avatar } from '@mui/material';
import COLORS from 'theme/colors';
import { SiblingProfile, siblingColor, siblingInitials } from './siblingProfile';

/**
 * MM-1123: props of SiblingAvatar.
 */
interface SiblingAvatarProps {
  /** Child to draw. */
  sibling?: SiblingProfile;
  /** Full sibling list, used to pick the child's stable accent colour. */
  siblings?: SiblingProfile[];
  /** Diameter in px. */
  size?: number;
}

/**
 * MM-1123: round avatar with the child's initials on the child's accent colour, so each child is
 * recognisable at a glance in the header, greeting and pickers.
 */
const SiblingAvatar = ({ sibling, siblings, size = 40 }: SiblingAvatarProps) => (
  <Avatar
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.38,
      fontWeight: 600,
      bgcolor: siblingColor(siblings, sibling),
      color: COLORS.DarkBlue,
    }}
  >
    {siblingInitials(sibling)}
  </Avatar>
);

export default SiblingAvatar;
